import React from 'react';

export interface EmojiProps {
    emoji: string;
    size?: number;
}

function Emoji({ emoji, size = 40 }: EmojiProps) {
    return <span style={{ fontSize: size, lineHeight: 1 }}>{emoji}</span>;
}

export { Emoji };